import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
} from '@tanstack/react-router';
import { Suspense } from 'react';

import type { RouterContext } from '@mint-lib/routing-context';

import {
  FlagsmithDevTools,
  TanStackRouterDevtools,
} from '../components/DevTools.js';
import ErrorComponent from '../components/ErrorComponent.jsx';
import { NotFound } from '../components/NotFound.jsx';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  errorComponent: ErrorComponent,
  notFoundComponent: NotFound,
  head: () => ({
    meta: [
      {
        title: 'MINT IQ',
      },
    ],
  }),
});

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <Suspense fallback={null}>
        <TanStackRouterDevtools />
        <FlagsmithDevTools />
      </Suspense>
      <Scripts />
    </>
  );
}
